module.exports = __webpack_public_path__ + "media/img/marquee/marquee-training-banner-33b585fa54d424e828754724d4185c9b.jpg";